// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "网络攻防技术",
      "tec": "李鲍",
      "week": "2-13周",
      "add": "教学楼B座222自控"
    },
    0,
    0,
    0,
    0
  ],
  "2": [
    {
      "sub": "移动应用开发",
      "tec": "张聿博",
      "week": "1-9周",
      "add": "实训楼F座606信机"
    },
    0,
    0,
    0,
    0
  ],
  "3": [
    {
      "sub": "网络服务管理与维护",
      "tec": "白雪峰",
      "week": "1-12周",
      "add": "教学楼C座405管理"
    },
    0,
    0,
    0,
    0
  ],
  "4": [
    0,
    0,
    0,
    0,
    0
  ],
  "5": [
    {
      "sub": "移动应用开发",
      "tec": "张聿博",
      "week": "1-9周",
      "add": "实训楼F座606信机"
    },
    0,
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
